exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../assets/styles/main.css"), "");

// module
exports.push([module.id, "\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-5bf9f280","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/vue-hotzone/lib/components/Hotzone.vue
// module id = 1505
// module chunks = 0